/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Controller } from "stimulus";
import { CountZabiegiApiURL } from "../../urls.js";
import debounce from "p-debounce";
import deklinacja from "deklinacja-od-ilosci";

const fetchCount = debounce(async function fetchCount(form: HTMLFormElement) {
	const form_data = new FormData(form);
	const response = await fetch(CountZabiegiApiURL, {
		body: form_data,
		method: "post",
	});
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const json = (await response.json()) as { count: string };
	return parseInt(json.count);
}, 250);

export default class MobileFilters extends Controller<HTMLFormElement> {
	static targets = ["submit"];

	public declare submitTarget: HTMLInputElement;

	async clear() {
		this.element
			.querySelectorAll(
				"input[type=checkbox][name=filters], input[type=checkbox][name^=has_prices]"
			)
			.forEach((checkbox: HTMLInputElement) => (checkbox.checked = false));
		await this.recalculate();
	}

	async recalculate() {
		const count = await fetchCount(this.element);
		const noun = deklinacja(count, "rozwiązanie", "rozwiązania", "rozwiązań");
		this.submitTarget.value = `Pokaż ${count} ${noun}`;
	}

	syncDuplicates(e: MouseEvent) {
		const value_name = (e.target as HTMLInputElement).getAttribute("value");
		const checked = (e.target as HTMLInputElement).checked;
		this.element
			.querySelectorAll(`[value="${value_name}"]`)
			.forEach((e: HTMLInputElement) => (e.checked = checked));
	}
}
